exports.bespaarData = [
  {
    gezin: "Gezin 14",
    "type energierekening": "juli 2019",
    "doel elek week": 49,
    "eindverbruik elek gem week": 47.078,
    stroom: -0.039224489795918305,
    "doel gas week": 1,
    "eindverbruik gas gem week": 0.46599999999999997,
    gas: -0.534
  },
  {
    gezin: "Gezin 18",
    "type energierekening": "sep 2018",
    "doel elek week": 48,
    "eindverbruik elek gem week": 48.94349999999997,
    stroom: 0.019656249999999487,
    "doel gas week": 4.1,
    "eindverbruik gas gem week": 3.82775,
    gas: -0.06640243902439014
  },
  {
    gezin: "Gezin 19",
    "type energierekening": "juni 2019",
    "doel elek week": 69,
    "eindverbruik elek gem week": 61.188500000000005,
    stroom: -0.11321014492753612,
    "doel gas week": 7.1,
    "eindverbruik gas gem week": 7.373642857142855,
    gas: 0.03854124748490917
  },
  {
    gezin: "Gezin 17",
    "type energierekening": "aug 2018",
    "doel elek week": 48,
    "eindverbruik elek gem week": 74.62,
    stroom: 0.5545833333333334,
    "doel gas week": 4.4,
    "eindverbruik gas gem week": 7.335249999999997,
    gas: 0.6671022727272717
  },
  {
    gezin: "Gezin 15",
    "type energierekening": "verg. huishouden",
    "doel elek week": 58,
    "eindverbruik elek gem week": 28.63,
    stroom: -0.5063793103448275,
    "doel gas week": 12,
    "eindverbruik gas gem week": 7.586249999999995,
    gas: -0.36781250000000043
  },
  {
    gezin: "Gezin 16",
    "type energierekening": "sep 2018",
    "doel elek week": 27,
    "eindverbruik elek gem week": 26.333999999999975,
    stroom: -0.024666666666667614,
    "doel gas week": 3,
    "eindverbruik gas gem week": 3.6837499999999976,
    gas: 0.22791666666666588
  },
  {
    gezin: "Gezin 6",
    "type energierekening": "sep 2018",
    "doel elek week": 90,
    "eindverbruik elek gem week": 75.73424999999997,
    stroom: -0.15850833333333358,
    "doel gas week": 10.3,
    "eindverbruik gas gem week": 6.56875,
    gas: -0.3622572815533981
  },
  {
    gezin: "Gezin 1",
    "type energierekening": "sep 2018",
    "doel elek week": 41,
    "eindverbruik elek gem week": 43.51674999999997,
    stroom: 0.06138414634146283
  },
  {
    gezin: "Gezin 3",
    "type energierekening": "sep 2018",
    "doel elek week": 74,
    "eindverbruik elek gem week": 48.728750000000005,
    stroom: -0.3415033783783783,
    "doel gas week": 2.1,
    "eindverbruik gas gem week": 2.103214285714283,
    gas: 0.0015306122448965898
  },
  {
    gezin: "Gezin 2",
    "type energierekening": "verg. huishouden",
    "doel elek week": 58,
    "eindverbruik elek gem week": 51.48425,
    stroom: -0.11234051724137928,
    "doel gas week": 9,
    "eindverbruik gas gem week": 6.014749999999994,
    gas: -0.33169444444444507
  },
  {
    gezin: "Gezin 5",
    "type energierekening": "verg. huishouden",
    "doel elek week": 80,
    "eindverbruik elek gem week": 51.91525,
    stroom: -0.35105937499999995,
    "doel gas week": 12,
    "eindverbruik gas gem week": 3.438928571428569,
    gas: -0.7134226190476192
  },
  {
    gezin: "Gezin 4",
    "type energierekening": "verg. huishouden",
    "doel elek week": 80,
    "eindverbruik elek gem week": 38.179249999999975,
    stroom: -0.5227593750000004,
    "doel gas week": 14,
    "eindverbruik gas gem week": 4.2684999999999995,
    gas: -0.6951071428571429
  },
  {
    gezin: "Gezin 8",
    "type energierekening": "juli 2019",
    "doel elek week": 24,
    "eindverbruik elek gem week": 22.375,
    stroom: -0.06770833333333337,
    "doel gas week": 3.7,
    "eindverbruik gas gem week": 2.3207499999999976,
    gas: -0.372770270270271
  },
  {
    gezin: "Gezin 12",
    "type energierekening": "sep 2018",
    "doel elek week": 38,
    "eindverbruik elek gem week": 36.417249999999974,
    stroom: -0.04165131578947434,
    "doel gas week": 3.9,
    "eindverbruik gas gem week": 3.550321428571426,
    gas: -0.08966117216117275
  },
  {
    gezin: "Gezin 7",
    "type energierekening": "sep 2018",
    "doel elek week": 44,
    "eindverbruik elek gem week": 39.27599999999997,
    stroom: -0.1073636363636371,
    "doel gas week": 7.8,
    "eindverbruik gas gem week": 5.624999999999998,
    gas: -0.2788461538461541
  },
  {
    gezin: "Gezin 9",
    "type energierekening": "juni 2019",
    "doel elek week": 51,
    "eindverbruik elek gem week": 34.71525,
    stroom: -0.3193088235294118,
    "doel gas week": 3.2,
    "eindverbruik gas gem week": 2.3302499999999977,
    gas: -0.2717968750000007
  },
  {
    gezin: "Gezin 10",
    "type energierekening": "verg. huishouden",
    "doel elek week": 80,
    "eindverbruik elek gem week": 49.82175,
    stroom: -0.377228125,
    "doel gas week": 16,
    "eindverbruik gas gem week": 2.7958928571428574,
    gas: -0.8252566964285715
  },
  {
    gezin: "Gezin 11",
    "type energierekening": "juli 2019",
    "doel elek week": 64,
    "eindverbruik elek gem week": 67.54992857142858,
    stroom: 0.05546763392857157,
    "doel gas week": 16.8,
    "eindverbruik gas gem week": 12.24325,
    gas: -0.2712351190476191
  },
  {
    gezin: "Gezin 20",
    "type energierekening": "verg. huishouden",
    "doel elek week": 70,
    "eindverbruik elek gem week": 52.30775,
    stroom: -0.2527464285714286,
    "doel gas week": 9,
    "eindverbruik gas gem week": 5.8529642857142825,
    gas: -0.3496706349206353
  },
  {
    gezin: "Gezin 13",
    "type energierekening": "verg. huishouden",
    "doel elek week": 80,
    "eindverbruik elek gem week": 28.03575,
    stroom: -0.649553125,
    "doel gas week": 9,
    "eindverbruik gas gem week": 4.7325,
    gas: -0.4741666666666666
  }
];
